export const iconFontAwesomeBuildingsArchway = (
	<i className="fa-solid fa-archway"></i>
);
